
import { Placement } from '@post-office/placements-frontend/goals-screen-space-flags';
export default Placement;
